export interface IParams {
  [key: string]: any;
}

export function parseSearch(search: string): IParams {
  const o = {} as IParams;
  (search.charAt(0) === '?' ? search.substr(1) : search).split('&').forEach((entry: string) => {
    if (typeof entry === 'string') {
      const [k, v] = entry.split('=');
      if (k) {
        o[decodeURIComponent(k)] = decodeURIComponent(v);
      }
    }
  });
  return o;
}
